/* Card help "?" (kit .cardhelp). The visible circle is 22 px; the hit area is 44 px. */
.trigger {
  position: relative;
  display: inline-grid;
  /* QA-053: never squeezed by a card head's title on a narrow screen. */
  flex-shrink: 0;
  place-items: center;
  width: 32px;
  height: 32px;
  margin: -6px -4px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  vertical-align: middle;
}

.trigger::before {
  content: '';
  position: absolute;
  inset: -6px;
}

.dot {
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border: 1px solid var(--border-control);
  border-radius: 50%;
  background: var(--white);
  color: var(--text-secondary);
  font: 600 12px/1 var(--font-ui);
  transition:
    border-color var(--dur-fast) ease,
    box-shadow var(--dur-fast) ease,
    color var(--dur-fast) ease;
}

.trigger[data-hovered] .dot,
.trigger[data-focus-visible] .dot,
.trigger[data-pressed] .dot,
.trigger[aria-expanded='true'] .dot {
  border-color: var(--brand-cyan);
  color: var(--brand-petrol);
  box-shadow: var(--focus-halo);
}

.trigger[data-focus-visible] {
  outline: none;
}

.onDark .dot {
  border-color: var(--white-a45);
  background: var(--white);
  color: var(--brand-navy);
}

.popover {
  width: 280px;
  max-width: calc(100vw - 32px);
  border-radius: var(--radius-md);
  background: var(--brand-navy-950);
  color: var(--text-on-dark-soft);
  box-shadow: var(--shadow-popover);
}

.popover[data-entering] {
  animation: pop var(--dur-fast) ease-out;
}

@keyframes pop {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
}

.dialog {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  font: 400 13px/1.55 var(--font-body);
  text-align: left;
  text-transform: none;
  letter-spacing: 0;
  outline: none;
}

.label {
  margin: 0;
  color: var(--white);
  font-size: 12px;
  font-weight: var(--fw-semibold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.label + p + .label {
  margin-top: 8px;
}

.text {
  margin: 0;
}
